import styled from 'styled-components';
import { DimmedBackground } from '../../../common/dimmed/DimmedBackground';
import { YoutubeSection } from '../../../common/video/YoutubeSection';

interface YoutubePlayerModalProps {
  isShow: boolean;
  youtubeUrl: string;
  handleModalClose: () => void;
}

export const YoutubePlayerModal = ({ isShow, youtubeUrl, handleModalClose }: YoutubePlayerModalProps) => {
  return (
    <DimmedBackground isShow={isShow} onClick={handleModalClose}>
      <Container
        onClick={(e) => {
          e.stopPropagation();
        }}
      >
        <YoutubeSection youtubeUrl={youtubeUrl} />
      </Container>
    </DimmedBackground>
  );
};

const Container = styled.div`
  width: 80vw;

  display: flex;
  justify-content: center;
  align-items: center;

  position: absolute;
  left: 50%;
  top: 50%;

  transform: translate(-50%, -50%);
`;
